import { render, staticRenderFns } from "./ShipmentsInquiryGridItem.vue?vue&type=template&id=ffc309ee&"
import script from "./ShipmentsInquiryGridItem.vue?vue&type=script&lang=js&"
export * from "./ShipmentsInquiryGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports